// extracted by mini-css-extract-plugin
export default {"about":"style_about__Rs0ed","about__cardList":"style_about__cardList__EXQFo","about__title":"style_about__title__ghEm8"};